import { Icon } from '@trussworks/react-uswds';

import './MaintenanceBanner.scss';
import { useDeveloperStore } from '@stores';

const shouldOverrideBackendBanner = import.meta.env.VITE_OVERRIDE_BACKEND_BANNER === 'true';
const outageMessage = `We're currently experiencing an issue affecting RRS login and other services. Our team is working to restore service as quickly as possible. Please try again later.`;

const MaintenanceBanner = () => {
  const { bannerInfo } = useDeveloperStore();
  const { banner, isBannerOn } = bannerInfo;

  const shouldShowBanner = shouldOverrideBackendBanner || isBannerOn;

  if (!shouldShowBanner) {
    return null;
  }

  const bannerMessage = shouldOverrideBackendBanner ? outageMessage : banner;

  return (
    <div className='app-banner'>
      <Icon.Error className='app-banner-icon warning-icon' role='img' aria-label='Site Notice' />
      {bannerMessage}
    </div>
  );
};

export default MaintenanceBanner;
